import { autoinject } from 'aurelia-framework';
import { QueryFilter } from 'lib/tables/DataFilter';
import { Models } from 'models/core';
import { AuthHttpClient } from 'services/auth-http-client';
import { BaseApiService } from 'services/base-api-service';

@autoinject
export class SewingThreadTypeServiceService extends BaseApiService<Models.SewingThreadTypeService> {
  constructor(httpClient: AuthHttpClient) {
    super(httpClient, Models.SewingThreadTypeService);
  }

  public getSewingThreadTypeServiceList(filters: QueryFilter) {
    return this.httpClient.execWithResponseMeta<any[]>(`${Models.SewingThreadTypeService.ApiUrl}/list${filters.asQueryString}`, {
      method: 'GET',
    });
  }

  public async checkDuplicate(data: Models.CheckDuplicateSewingThreadTypeService) {
    return await this.httpClient.exec<{ IsDuplicate: boolean }>(`${Models.SewingThreadTypeService.ApiUrl}/checkDuplicate`, {
      method: 'POST',
      body: JSON.stringify(data),
    });
  }
}
